<template>
  <b-card>
    <p>Other settings will be implemented here.</p>
  </b-card>
</template>

<script>
export default {
  name: 'OtherSettings',
  computed: {
    labels() {
      return this.$store.state.labels;
    },
  },
};
</script>
